
const HowItWorksSection = () => {
  const scrollToFinalCTA = () => {
    const element = document.getElementById('final-cta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#34444b] mb-6">
            How It Works
          </h2>
          <p className="text-xl text-[#73807c] max-w-2xl mx-auto">
            Simple. Straightforward. No surprises. Here's exactly what happens when you work with us.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="w-20 h-20 bg-[#708474] rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl font-bold text-white">1</span>
            </div>
            <h3 className="text-xl font-bold text-[#34444b] mb-4">Choose Your Package</h3>
            <p className="text-[#73807c] leading-relaxed">
              Pick from Takeoff ($750), Flight Path ($1,850), or First Class ($4,500). Or start with a project and move to retainer when you see the results.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-[#708474] rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl font-bold text-white">2</span>
            </div>
            <h3 className="text-xl font-bold text-[#34444b] mb-4">We Analyze & Strategize</h3>
            <p className="text-[#73807c] leading-relaxed">
              We study your business, your market, your competitors. You answer our questions. If it's First Class, we have a strategy call to dig deeper.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-[#708474] rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl font-bold text-white">3</span>
            </div>
            <h3 className="text-xl font-bold text-[#34444b] mb-4">You Get Results</h3>
            <p className="text-[#73807c] leading-relaxed">
              High-converting copy delivered in 7-14 days. You use it everywhere. Watch your business move. Most clients see results in 2-3 weeks.
            </p>
          </div>
        </div>

        <div className="bg-[#708474]/10 p-8 rounded-lg text-center">
          <h3 className="text-2xl font-bold text-[#34444b] mb-4">
            The Retainer Truth
          </h3>
          <p className="text-xl text-[#73807c] leading-relaxed max-w-3xl mx-auto">
            Most clients move to retainer because they want to work with us indefinitely. This is built on trust, not obligation. We don't lock you into contracts—we earn your business every month.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <i className="ri-time-line text-[#708474] text-xl mr-3"></i>
              <h4 className="text-lg font-bold text-[#34444b]">Fast Turnaround</h4>
            </div>
            <p className="text-[#73807c]">
              7-14 days for most projects. Rush delivery available for +50% if you need it faster.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center mb-4">
              <i className="ri-shield-check-line text-[#708474] text-xl mr-3"></i>
              <h4 className="text-lg font-bold text-[#34444b]">Confidentiality Available</h4>
            </div>
            <p className="text-[#73807c]">
              Working in a sensitive industry? We offer confidentiality agreements for complete peace of mind.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
